module.exports = __webpack_public_path__ + "img/vivense-new-logo.26e267b6.svg";